import type { FetchCollectionParameters } from '@app/src/api/fetchHooks'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { SortOrder } from '@app/src/types/filter'

export const PROVIDER_SEARCH_PAGE_SIZE = 20

// A blank query means "show me what I can pick", not "match the empty string": the editor opens
// on a row whose supplier is missing or unresolved, so the first page of the organization's
// providers has to be browsable without typing.
export function buildProviderSearchPayload(query: string): FetchCollectionParameters<unknown>['payload'] {
  const trimmed = query.trim()

  return {
    filter: trimmed ? [{ name: 'name', filters: [{ operator: Operators.Contains, value: trimmed }] }] : [],
    include: ['country'],
    sort: { target: 'name', order: SortOrder.ASCENDING },
    pagination: { pageNumber: 1, itemsPerPage: PROVIDER_SEARCH_PAGE_SIZE },
  }
}
